import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  className = '',
  hover = false,
  padding = 'medium',
  ...props 
}) => {
  const cardClass = `card card-${padding} ${hover ? 'card-hover' : ''} ${className}`;
  
  return (
    <div className={cardClass} {...props}>
      {children}
    </div>
  );
};

export default Card;
